import { render, staticRenderFns } from "./BoxOfficeSales.vue?vue&type=template&id=2ea70262&"
import script from "./BoxOfficeSales.vue?vue&type=script&lang=js&"
export * from "./BoxOfficeSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports